import React, { Fragment, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Row, Col, Form } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import UserSelection from "./UserSelection";
import {
  ButtonModalFormSaveClose,
  ButtonModalFormSaveCloseThirdAction,
} from "./ButtonModalSelection";
import { UserNoteDelete } from "../modals/UserNoteDelete";

export const UserNoteCreation = ({
  userNote,
  defaultUser,
  onComplete,
  close = null,
}) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [disableUserSelection, setDisableUserSelection] = useState(false);
  const [type, setType] = useState("GENERAL");
  const [note, setNote] = useState("");
  const [noteValid, setNoteValid] = useState(false);
  const [shiftValid, setShiftValid] = useState(true);
  const [shiftLink, setShiftLink] = useState(null);
  const [shiftTable, setShiftTable] = useState(null);
  const [shiftId, setShiftId] = useState(null);
  const [userNoteDeleteModalVisable, setUserNoteDeleteModalVisable] =
    useState(false);
  const [contentVisible, setContentVisible] = useState(true);

  useEffect(() => {
    if (defaultUser !== null && defaultUser !== undefined) {
      setUser(defaultUser);
      setDisableUserSelection(true);
    }
  }, [defaultUser]);

  useEffect(() => {
    const contentValid = note !== null && note !== undefined && note !== "";
    setNoteValid(contentValid);

    const enabled = shiftValid && user !== null && contentValid;
    setSaveDisabled(!enabled);
  }, [shiftValid, user, type, note]);

  useEffect(() => {
    if (shiftLink === null || shiftLink === undefined || shiftLink === "") {
      setShiftValid(true);
      return;
    }

    try {
      const url = new URL(shiftLink);
      const path = url.pathname;
      const tokens = path.split("/");

      /*
          /archiveShifts/view/910024 UserNoteCreation.js:49
          Array(4) [ "", "archiveShifts", "view", "910024" ]
          ​
          0: ""
          1: "archiveShifts"
          2: "view"
          3: "910024"
          length: 4
        */
      if (tokens.length !== 4) {
        setShiftValid(false);
        return;
      }

      const entity = tokens[1];
      if (entity !== "shifts" && entity !== "archiveShifts") {
        setShiftValid(false);
        return;
      }

      const action = tokens[2];
      if (action !== "view") {
        setShiftValid(false);
        return;
      }

      const associatedShift = tokens[3];
      if (associatedShift === "" || associatedShift === null) {
        setShiftValid(false);
        return;
      }

      const associatedShiftId = parseInt(associatedShift);
      if (isNaN(associatedShiftId)) {
        setShiftValid(false);
        return;
      }

      setShiftTable(entity === "shifts" ? "shifts" : "shifts_archived");
      setShiftId(associatedShiftId);
    } catch (err) {
      setShiftValid(false);
    }
  }, [shiftLink]);

  useEffect(() => {
    if (userNote === null || userNote === undefined) return;

    setUser(userNote?.user);
    setType(userNote?.type);
    setNote(userNote?.note);

    if (userNote?.shift !== null && userNote?.shift !== undefined) {
      setShiftId(userNote?.shift?.id);
      setShiftTable(userNote?.shift?.table);

      if (
        userNote?.shift?.id !== null &&
        userNote?.shift?.id !== undefined &&
        userNote?.shift?.table !== null &&
        userNote?.shift?.table !== undefined
      ) {
        const table =
          userNote?.shift?.table === "shift" ? "shifts" : "archiveShifts";
        const link =
          "https://backoffice.axisagency.co.uk/" +
          table +
          "/view/" +
          userNote?.shift?.id;
        setShiftLink(link);
      } else {
        setShiftLink(null);
      }
    }
  }, [userNote]);

  const onSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        type: type,
        note: note,
        userId: user?.id,
        associatedShiftId: shiftId,
        table: shiftTable,
      };

      var params = {};
      const isUpdate = userNote?.id !== null && userNote?.id !== undefined;
      if (isUpdate) params["user_note_id"] = userNote?.id;

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(
        "/api/backoffice/users/" +
          (isUpdate ? "update_user_note" : "new_user_note"),
        payload,
        config,
      );

      if (onComplete !== null && onComplete !== undefined)
        onComplete(response.data);
    } catch (err) {
      setLoading(false);
      console.log("error:");
      console.log(err);
    }
  };

  const typeChanged = (value) => {
    var text = value.target.value;
    setType(text);
  };

  const noteChanged = (value) => {
    var text = value.target.value;
    setNote(text);
  };

  const shiftChanged = (value) => {
    var text = value.target.value;
    setShiftLink(text);
  };

  const deleteModalClose = () => {
    setUserNoteDeleteModalVisable(false);
    setContentVisible(true);
  };

  const openDeleteModal = () => {
    setUserNoteDeleteModalVisable(true);
    setContentVisible(false);
  };

  const displayContent = () => {
    if (!contentVisible) return null;
    return (
      <Fragment>
        <Form onSubmit={onSave} id="message-form">
          <Form.Group className="mb-3" controlId="formUserType">
            <Row>
              <Col xs lg="2">
                <Form.Label>Note Type:</Form.Label>
              </Col>
              <Col xs lg="4">
                <Form.Select value={type} onChange={typeChanged}>
                  <option value="GENERAL">General</option>
                  <option value="LATE">Late</option>
                  <option value="CANCELLATION">Cancellation</option>
                  <option value="STRIKE">Strike</option>
                  <option value="CERT">Cert</option>
                  <option value="USER_STATUS">User Status</option>
                  <option value="TIMESHEET">Timesheet</option>
                </Form.Select>
              </Col>
            </Row>
          </Form.Group>

          <Form.Group className="mb-3" as={Col} controlId={"formMessage"}>
            <Form.Label>Note:</Form.Label>
            <Form.Control
              as="textarea"
              style={{ height: "10em" }}
              value={note}
              onChange={noteChanged}
              isValid={noteValid}
              isInvalid={!noteValid}
              required
            />
            <Form.Control.Feedback type={"invalid"}>
              Needs to have a note
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formAssociatedShift">
            <Row>
              <Col xs lg="2">
                <Form.Label>Related Shift:</Form.Label>
              </Col>
              <Col xs lg="8">
                <Form.Control
                  type="text"
                  placeholder="https://backoffice.axisagency.co.uk/shifts/view/XXXXX"
                  value={shiftLink}
                  onChange={shiftChanged}
                  isValid={shiftValid}
                  isInvalid={!shiftValid}
                />
              </Col>
              <Form.Control.Feedback type="invalid">
                Invalid shift
              </Form.Control.Feedback>
            </Row>
          </Form.Group>
        </Form>

        {userNote !== null ? (
          <ButtonModalFormSaveCloseThirdAction
            saveName={"Save"}
            close={close}
            formSave={onSave}
            loading={loading || saveDisabled}
            thirdActionName={"Delete"}
            thirdActionAction={openDeleteModal}
          />
        ) : (
          <ButtonModalFormSaveClose
            saveName={"Save"}
            close={close}
            formSave={onSave}
            loading={loading || saveDisabled}
          />
        )}
      </Fragment>
    );
  };

  return (
    <Fragment>
      {displayContent()}
      <UserNoteDelete
        visible={userNoteDeleteModalVisable}
        close={deleteModalClose}
        user={user}
        userNote={userNote}
        onComplete={onComplete}
      />
    </Fragment>
  );
};
